import axios from 'axios'

export default {
  namespaced: true,
  state: {
    topics: []
  },
  getters: {
    topics:(state)=>state.topics
  },
  mutations: {
    get (state, data) {
      state.topics = data.topics
    },
  },
  actions: {
    async get({ commit }) {
      const response = await axios.get(process.env.VUE_APP_API_BASE_URL + '/topic' + this.$route.query.search)
      commit('get', response.data)
      return response.data
    },
  },
}
